exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-55b30c1f] {\n  color: #232323;\n  font-size: 24px;\n  text-align: center;\n}\n.address-pickl-list[data-v-55b30c1f] {\n  border: solid 1px rgb(230, 227, 227);\n  padding: 5px;\n}\n", ""]);

// exports
